import { FC } from 'react';
import { Button } from '@mui/material';
import { useDownload } from 'hooks/ui/useDownload';

type Props = {
  investorId: string;
  investorName: string;
  firmId: string;
};

const DownloadTransferButton: FC<Props> = ({
  investorId,
  investorName,
  firmId,
}) => {
  const download = useDownload({
    filename: `Transfer Form for completion - The Late ${investorName}.xlsx`,
    errorMessage: 'The transfer form could not be downloaded',
  });

  if (!firmId) {
    return null;
  }

  const downloadTransferForm = () => {
    download.mutate(`investor/download-transfer-form/${firmId}/${investorId}`);
  };

  return (
    <Button
      size="extra-small"
      variant="outlined"
      color="primary"
      onClick={() => {
        downloadTransferForm();
      }}
    >
      Download transfer form
    </Button>
  );
};

export default DownloadTransferButton;
